export default "__VITE_ASSET__s0DOsr5d__"